import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, inject, signal } from '@angular/core';
import { PanoptycDataService } from '../../../service/panoptyc-data.service';
import { MatDialogRef } from '@angular/material/dialog';
import { UserLoginService } from '../../../service/user-login.service';
import { Router } from '@angular/router';
import { hasStatus } from '../../../error.utils';
import { SharedTransactionDetails } from '../../../types';

@Component({
  selector: 'app-shared-transaction-details-popup',
  templateUrl: './transaction-details-popup.component.html',
  styleUrls: ['./transaction-details-popup.component.scss'],
  standalone: false,
})
export class TransactionDetailsPopupComponent implements OnInit {
  userService = inject(UserLoginService);
  router = inject(Router);
  private dataService = inject(PanoptycDataService);
  private dialogRef = inject<MatDialogRef<TransactionDetailsPopupComponent>>(MatDialogRef);

  cancellationId: string;
  theftLabel: string;
  lastSeen: string;
  hasVideo: boolean;

  session: any;
  hasDetails: boolean;

  public hasComments = signal<boolean>(false);
  public isTheft = signal<boolean>(false);
  public transactionDetails = signal<SharedTransactionDetails | null>(null);
  public loadingData = signal<boolean>(true);

  constructor() {
    const data = inject(MAT_DIALOG_DATA);

    this.cancellationId = data.cancellationId;
    this.session = data.session;
    this.lastSeen = data.lastSeen;
    this.hasVideo = data.hasVideo;
    this.hasDetails = data.hasDetails;
    this.hasComments.set(data.hasComments);
    this.isTheft.set(data.isTheft);
  }

  handleDataForbidden(error: unknown) {
    if (hasStatus(error) && error.status === 403) {
      try {
        this.router.navigate(['/403']);
      } catch (e) {
        console.error(e);
      }
    }
  }

  ngOnInit() {
    this.dataService.getTransactionDetails(this.cancellationId).subscribe(
      (response) => {
        this.transactionDetails.set(response);
        this.loadingData.set(false);
        this.dataService.setTransactionViewed(this.cancellationId).subscribe(
          () => {
            this.lastSeen = '2019-12-12 18:23:38.000000';
          },
          (error) => {
            this.handleDataForbidden(error);
          },
        );
      },
      (error) => {
        this.loadingData.set(false);
        this.handleDataForbidden(error);
      },
    );
  }

  theftToValue(isTheft) {
    if (isTheft === true) {
      return 1;
    }
    if (isTheft === false) {
      return 0;
    }
    return isTheft;
  }

  handleMisidentifiedFace(event: { remove: boolean; isTheft: boolean }) {
    if (event.remove === true) {
      this.dialogRef.close({
        isTheft: this.theftToValue(this.isTheft()),
        theftLabel: this.theftLabel,
        isViewed: this.lastSeen,
        hasVideo: this.hasVideo,
        hasComments: this.hasComments,
        remove: true,
      });
    }
  }

  handleTheftCategoryChange(event: { isTheft: boolean }) {
    this.isTheft.set(event.isTheft);
  }

  handleNewComment() {
    this.hasComments.set(true);
  }
}
